import { Component, ElementRef, Input } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { AppUpdate, AppUpdateResultCode, FlexibleUpdateInstallStatus } from '@capawesome/capacitor-app-update';
import { Platform, PopoverController } from '@ionic/angular';
import { UPDATE_STRATEGY } from 'src/app/app.component';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-update',
  templateUrl: './app-update.component.html',
  styleUrls: ['./app-update.component.scss'],
})
export class AppUpdateComponent {

  @Input()
  updateStrategy: UPDATE_STRATEGY | undefined;

  constructor(
    private popoverCtrl: PopoverController,
    private ref: ElementRef,
    private platform: Platform,
    private toastService: ToastService,
  ) {
    if (this.ref.nativeElement.hasAttribute('popover')) {
      this.ref.nativeElement.removeAttribute('popover');
    }
  }

  dismiss() {
    this.popoverCtrl.dismiss();
  }

  async update() {
    if (Capacitor.isNativePlatform()) {
      const appUpdateInfo = await AppUpdate.getAppUpdateInfo();
      if (this.platform.is('android')) {
        if (this.updateStrategy === UPDATE_STRATEGY.IMMEDIATE && appUpdateInfo.immediateUpdateAllowed) {
          await AppUpdate.performImmediateUpdate();
        } else if (this.updateStrategy === UPDATE_STRATEGY.OPTIONAL) {
          if (appUpdateInfo.flexibleUpdateAllowed) {
            const listener = AppUpdate.addListener('onFlexibleUpdateStateChange', (res) => {
              if (res.installStatus === FlexibleUpdateInstallStatus.DOWNLOADED) {
                AppUpdate.completeFlexibleUpdate();
                listener.remove();
              }
            });
            const result = await AppUpdate.startFlexibleUpdate();
            if (result.code === AppUpdateResultCode.OK) {
              this.toastService.show('The app is updating in the background. It will automatically restart the app after the update', 5000);
              this.popoverCtrl.dismiss(true);
            }
          } else {
            await AppUpdate.openAppStore();
          }
        }
      } else if (this.platform.is('ios')) {
        await AppUpdate.openAppStore();
      }
    }
  }

}
